import { render, staticRenderFns } from "./TwitterAddProfileDialog.vue?vue&type=template&id=25cc12d8&scoped=true"
import script from "./TwitterAddProfileDialog.vue?vue&type=script&lang=js"
export * from "./TwitterAddProfileDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cc12d8",
  null
  
)

export default component.exports